export default __webpack_public_path__ + "static/media/out_out_icon.60ea43ee.svg";